import { IBrowserTestEnvironment, BrowserTestEnvironmentConfig } from '../../interfaces/test-environment/IBrowserTestEnvironment';
import { IMochaInstance } from '../../interfaces/test-environment/IMochaInstance';
import '../../interfaces/browser'; // Import global declarations

export class BrowserTestEnvironment implements IBrowserTestEnvironment {
  private config: BrowserTestEnvironmentConfig;

  constructor(config: BrowserTestEnvironmentConfig = {}) {
    this.config = {
      defaultReporter: 'html',
      enableDetailedReporter: false,
      ...config
    };
  }

  createMochaInstance(sessionLabel: string): IMochaInstance {
    const resultKey = `results_${sessionLabel.replace(/\s+/g, '_')}`;
    
    const detailedReporterAvailable = this.config.enableDetailedReporter && 
      window.MochaDetailedReporter?.DetailedJsonReporter !== undefined;
    
    return new window.Mocha({
      ui: 'bdd',
      reporter: detailedReporterAvailable ? 
        window.MochaDetailedReporter!.DetailedJsonReporter : 
        window.Mocha.reporters.HTML,
      reporterOptions: {
        outputToWindow: 'true',
        windowVariableName: resultKey
      },
      ...this.config.mochaOptions
    });
  }

  injectGlobals(mochaInstance: IMochaInstance): void {
    mochaInstance.suite.emit('pre-require', window, null, mochaInstance);
    
    if (window.chai) {
      window.expect = window.chai.expect;
    }
  }

  setupDOM?(): void {
    if (this.config.globalSetup) {
      const setupResult = this.config.globalSetup();
      if (setupResult instanceof Promise) {
        setupResult.catch(console.error);
      }
    }
  }

  cleanupDOM?(): void {
    // Default cleanup implementation
    const containers = document.querySelectorAll('[data-session-container]');
    containers.forEach(container => container.remove());
  }

  validateEnvironment(): boolean {
    return !!(window.Mocha && window.chai);
  }
}
